module.exports = __webpack_public_path__ + "img/serve2.6d6c7202.png";